var _a, _b;
export var UserType;
(function (UserType) {
    UserType[UserType["User"] = 0] = "User";
    UserType[UserType["Robot"] = 1] = "Robot";
    UserType[UserType["DirectoryUser"] = 2] = "DirectoryUser";
    UserType[UserType["DirectoryGroup"] = 3] = "DirectoryGroup";
})(UserType || (UserType = {}));
export var ADResultType;
(function (ADResultType) {
    ADResultType[ADResultType["User"] = 0] = "User";
    ADResultType[ADResultType["Group"] = 1] = "Group";
})(ADResultType || (ADResultType = {}));
export var USER_ICON_MAP = (_a = {},
    _a[UserType.User] = { matIcon: 'person' },
    _a[UserType.Robot] = { svgIcon: 'uipath:robots' },
    _a[UserType.DirectoryUser] = { svgIcon: 'uipath:ad-user' },
    _a[UserType.DirectoryGroup] = { matIcon: 'group' },
    _a);
export var AD_TO_USER_MAP = (_b = {},
    _b[ADResultType.User] = UserType.DirectoryUser,
    _b[ADResultType.Group] = UserType.DirectoryGroup,
    _b);
export var UserRobotAccess;
(function (UserRobotAccess) {
    UserRobotAccess[UserRobotAccess["Disabled"] = 0] = "Disabled";
    UserRobotAccess[UserRobotAccess["Enabled"] = 1] = "Enabled";
    UserRobotAccess[UserRobotAccess["Group"] = 2] = "Group";
})(UserRobotAccess || (UserRobotAccess = {}));
export var USER_ROBOT_ACCESS_FILTER = {
    Disabled: [{
            property: 'mayHaveRobotSession',
            method: 'eq',
            value: false,
        }],
    Group: [{
            property: 'mayHaveRobotSession',
            method: 'eq',
            value: true,
        }, {
            property: 'licenseType',
            method: 'eq',
            value: null,
        }, {
            property: 'type',
            method: 'eq',
            value: UserType[UserType.DirectoryUser],
        }],
    Enabled: [{
            property: 'mayHaveRobotSession',
            method: 'eq',
            value: true,
        }, {
            property: 'licenseType',
            method: 'ne',
            value: null,
        }],
};
